module.exports = __webpack_public_path__ + "static/media/tk.0f4fb02a.svg";